import CustomizationRequest from "../customization/request";

/*
    Event handler for cases where the customization controller needs to wait
    for the iframe to load and finish rendering default customizations.
 */

export const onCustomizationRendered = (action, option) => {
  /*
      Implementing https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#once
      manually, as other sources of postMessage can raise the event before site builder does.
   */
  function handler(event) {
    const payload = CustomizationPayloadEvent.parse(event);
    if (payload?.rendered) {
      action(payload);

      if (option?.once) {
        window.removeEventListener("message", handler);
      }
    }
  }

  window.addEventListener("message", handler);
};

export const onCustomizationChange = (action) => {
  window.addEventListener("message", (event) => {
    const payload = CustomizationPayloadEvent.parse(event);
    if (payload) {
      action(payload);
    }
  });
};

export const onPageChange = (action) => {
  window.addEventListener("message", (event) => {
    const { type } = event.data;
    if (type === "siteBuilderPageChange") {
      action();
    }
  });
};

export const onLinkClick = (action) => {
  document.addEventListener("click", function (e) {
    const pageLinks =
      "#site-builder-preview-template body a[href^='/'], #site-builder-preview-template body a[href^='http']";

    /*
      Emulating JQuery's event delegation
    */
    for (
      let target = e.target;
      target && target !== this;
      target = target.parentNode
    ) {
      if (target.matches(pageLinks)) {
        action(e, target);
        break;
      }
    }
  });
};

export const onCustomizationFinish = (action) => {
  document.addEventListener("site-builder:customization-loaded", () => {
    action();
  });
};

export const onPreviewIframeFormSubmission = (action) => {
  CustomizationRequest.previewIframe()?.addEventListener("turbo:submit-start", (e) => {
    action(e.detail.formSubmission);
  });
};

export class CustomizationPayloadEvent {
  static type = "SiteBuilderCustomization";

  static parse(event) {
    const { type, data } = event.data;
    if (type !== CustomizationPayloadEvent.type) return null;

    return data;
  }

  constructor(values) {
    this.data = values;
  }

  get toObj() {
    return { type: this.constructor.type, data: this.data };
  }
}
